/* eslint-disable */
import moment from 'moment';
import * as _ from 'underscore';
import { normalize } from 'normalizr';
import qs from 'qs';

import * as ProgramService from '../../../api/service/programService';
import * as WorkoutService from '../../../api/service/workoutService';

import * as TeamService from '../../../api/service/teamService';

import CONF from '../../../api/config';
import { FEATURES } from '../../../v5/features/components/constants';
import { programCalendar } from '../../../lib/calendar';

import { getStore, getState } from '../../store';
import ACTIONS from './actions';
import DESIGNER_ACTIONS from '../designer/actions';
import WORKOUT_ACTIONS from '../workout/actionsCalendar';
import daySchema from '../day/schema';

import workoutSchema from '../workout/schema';

import * as ProgramTypes from './programTypes';
import * as Utils from '../../../lib/designerUtils';
import * as DateUtils from '../../../lib/dateUtils';

import * as Authorization from '../../../lib/authorization';
import * as AppState from '../app/appState';
import * as DesignerState from '../designer/designer';
import * as ClipboardState from '../clipboard/clipboard';
import * as SummaryState from '../summary/summary';
import * as ToastState from '../clipboard/toast';
import * as LibraryState from '../library/library';
import * as NavState from '../nav/nav';
import * as CalendarCollapseState from '../calendarCollapse/calendarCollapse';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';

const API = {
    ProgramService: ProgramService,
    WorkoutService: WorkoutService,
    TeamService: TeamService
};

export const addSession = async (session, saveProgramWorkoutFirst = true) => {
    const dayKey = Utils.getDayKey(session);
    const day = getState().calendar.dayTree[dayKey];

    if (day) {
        addFakeSessionToDay(day);
    }

    let savedSession = session;

    if (saveProgramWorkoutFirst) {
        savedSession = await API.ProgramService.saveProgramWorkouts([
            { ...session }
        ]);
    }

    if (day) {
        setTimeout(() => {
            const newSession = {
                ...session,
                ...savedSession[0]
            };
            addSessionFromCalendar(day, newSession);
        }, 100);
    }
};

export const addFakeSessionToDay = (day) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_ADD_FAKE_SESSION,
        day
    });
};

export const setAthlete = (userId) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_ATHLETE_INFO,
        currentUser: userId
    });
};

export const setExtraWork = (resp) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_EXTRA_DATA,
        extraWork: resp
    });
};

export const addProgramToAthlete = async (program) => {
    showLoading();
    const savedProgram = await API.ProgramService.addProgramToCalendar(program);
    const sessions = savedProgram.program_workouts;
    sessions.map((s) => addSession(s));
    hideLoading();
};

export const addSessionFromCalendar = (day, session, fromDay) => {
    getStore().dispatch({
        type: ACTIONS.SESSION_COPY,
        session,
        day,
        fromDay
    });
};

export const clearCalendarForLoading = () => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_EXTRA_CLEAR
    });
    getStore().dispatch({
        type: ACTIONS.NUTRITION_CLEAR
    });
    getStore().dispatch({
        type: ACTIONS.DAYS_CLEAR
    });
    getStore().dispatch({
        type: ACTIONS.CLEAR_INFO_TREE
    });
};

const load = async (
    programId,
    programType,
    dateData = {},
    fixedProgramLength
) => {
    AppState.setLoading('Loading Sessions...');
    let currentDate = null;

    const isNewProgram = getState().calendar.infoTree.programId !== programId;
    const isNewType = getState().calendar.infoTree.programType !== programType;
    const isReloadRequired = isNewProgram || isNewType;
    if (isReloadRequired) clearCalendarForLoading();

    if (!ProgramTypes.isProgram(programType)) {
        currentDate = DateUtils.convertToDate(dateData, 'YYYY-M-D');
    }
    DesignerState.setInfo(programType, { programType, ...dateData });

    programCalendar.init(programType, currentDate, 6, fixedProgramLength);

    const calendarData = getAllDaysFromCalendar(currentDate, programCalendar);

    await calendarSetup(
        programId, //todo : refactor this so its actually a programId
        calendarData.currentDay,
        calendarData.days,
        programType,
        dateData.year,
        dateData.month,
        fixedProgramLength
    );

    if (!isReloadRequired && isLoaded(dateData.year, dateData.month)) {
        return AppState.stopLoading();
    }

    if (isReloadRequired) await setupProgramInfo(programId, null, programType);

    await loadProgramWorkouts(
        programId,
        programType,
        dateData.year,
        dateData.month
    );

    if (!isReloadRequired) return AppState.stopLoading();

    setTimeout(AppState.stopLoading, 300);
    scrollCalendar();
    if (isReloadRequired) LibraryState.load();
};

export const loadInvitedAthleteCalendar = async (inviteId, year, month) => {
    AppState.setLoading('Loading...');
    const currentDate = DateUtils.convertToDate({ year, month }, 'YYYY-M-D');

    const isNewProgram = getState().calendar.infoTree.inviteId !== inviteId;
    if (isNewProgram) clearCalendarForLoading();

    const padding = 7;
    programCalendar.init(
        ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
        currentDate,
        padding
    );

    const days = getAllDaysFromCalendar(currentDate, programCalendar);

    await calendarSetup(
        inviteId,
        days.currentDay,
        days.days,
        ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
        year,
        month
    );

    const onFail = () =>
        NavState.redirectToTypeList(
            ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR
        );

    AppState.setLoading('Loading Sessions...');
    const programData = await API.ProgramService.getInvitedAthleteCalendar(
        inviteId,
        year,
        month,
        padding,
        onFail
    );

    await setupProgramInfo(
        programData.id,
        inviteId,
        ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR
    );

    loadProgramWorkouts(
        programData.id,
        ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
        year,
        month,
        programData
    );

    LibraryState.load();
    setAthlete(inviteId);
    scrollCalendar();
    return AppState.stopLoading();
};

export const loadAthleteCalendar = async (athleteId, year, month) => {
    AppState.setLoading('Loading...');
    const currentDate = DateUtils.convertToDate({ year, month }, 'YYYY-M-D');

    const isNewProgram = getState().calendar.infoTree.athleteId !== athleteId;
    if (isNewProgram) clearCalendarForLoading();

    programCalendar.init(
        ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
        currentDate,
        6
    );
    const days = getAllDaysFromCalendar(currentDate, programCalendar);

    await calendarSetup(
        athleteId,
        days.currentDay,
        days.days,
        ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
        year,
        month
    );

    if (isLoaded(year, month)) return loadSummaries(athleteId, year, month);

    const onFail = () =>
        NavState.redirectToTypeList(ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR);

    AppState.setLoading('Loading Sessions...');
    const programData = await API.ProgramService.getAthleteCalendar(
        athleteId,
        year,
        month,
        7,
        onFail
    );

    await setupProgramInfo(
        programData.id,
        athleteId,
        ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR
    );

    loadProgramWorkouts(
        programData.id,
        ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
        year,
        month,
        programData
    );

    scrollCalendar();

    LibraryState.load();
    setAthlete(athleteId);

    await addExtraWorkCards(athleteId, year, month);
    await loadSummaries(athleteId, year, month);
    await addNutritionCards(athleteId, year, month);

    return AppState.stopLoading();
};

const scrollCalendar = () => {
    return;
    // setTimeout(() => {
    //     const [questionMark, ...queryString] = location.search;
    //     const search = qs.parse(queryString.join(''));
    //     if (search.id) {
    //         const isDayElement = document.getElementById(search.id);
    //         if (isDayElement) {
    //             scrollToElement(isDayElement);
    //         }
    //         return;
    //     }
    //
    //     const isTodayElement = document.getElementsByClassName('is-today')[0];
    //     if (isTodayElement) {
    //         scrollToElement(isTodayElement);
    //     }
    // }, 50);
};

const scrollToElement = (element) => {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const scrollTo = elementRect.top - bodyRect.top - 175;
    const windowScrollTo = window.scrollY;
    if (Math.abs(windowScrollTo - scrollTo) > 10) {
        window.scrollTo(0, elementRect.top - bodyRect.top - 160);
    }
};

export const addExtraWorkCards = async (athleteId, year, month) => {
    AppState.setLoading('Loading Training...');
    const extraWorkData = await API.ProgramService.getAthleteExtraWork(
        athleteId,
        year,
        month,
        7
    );
    const extraWork = [];
    for (let i = 0; i < extraWorkData.length; i++) {
        const item = extraWorkData[i];
        item.pw_id = item.id;
        item.id = item.workout_id;
        item.eType = 'w';
        extraWork.push(item);
    }
    loadExtraWork(extraWork);
    setExtraWork(extraWork);
};

export const addNutritionCards = async (athleteId, year, month) => {
    AppState.setLoading('Loading Nutrition...');
    const isFeatureFlagEnabled =
        getState().features.web_coach_show_nutrition_on_calendar_v1;
    if (!isFeatureFlagEnabled) {
        return;
    }

    getStore().dispatch({
        type: ACTIONS.NUTRITION_LOADING
    });

    const baseDate = moment({ year: year, month: month - 1 });
    const startDate = baseDate
        .clone()
        .startOf('month')
        .subtract(7, 'days')
        .format('YYYY-MM-DD');
    const endDate = baseDate
        .clone()
        .endOf('month')
        .add(7, 'days')
        .format('YYYY-MM-DD');
    const nutritionData = await API.ProgramService.getAthleteNutrition(
        athleteId,
        startDate,
        endDate
    );

    if (nutritionData.status && nutritionData.status !== 200) {
        return;
    }

    loadNutrition(nutritionData);
    getStore().dispatch({
        type: ACTIONS.NUTRITION_LOADED
    });
};

export const loadSummaries = async (athleteId, year, month) => {
    AppState.setLoading('Loading Summaries...');
    const summaryData = await API.ProgramService.getAthleteCalendarSummary(
        athleteId,
        year,
        month,
        7
    );
    SummaryState.loadAthleteCalendarSummary(summaryData);
    AppState.stopLoading();
};

export const loadCalendar = async (programId, year, month, day) => {
    await load(programId, ProgramTypes.TYPES.CALENDAR, { year, month, day });
};

export const loadProgram = async (programId, dateData) => {
    setTimeout(async () => {
        const program = await API.ProgramService.getById(programId);
        load(programId, ProgramTypes.TYPES.FIXED, dateData, program.length);
    }, 0);
};

export const loadTeamCalendar = async (programId, year, month, day) => {
    await load(programId, ProgramTypes.TYPES.TEAM, { year, month, day });
    return loadTeamCalendarSummary(programId, year, month);
};

export const loadTeamCalendarSummary = async (programId, year, month) => {
    AppState.setLoading('Loading session summaries...');
    const summaryData = await API.ProgramService.getTeamCalendarSummary(
        programId,
        year,
        month,
        7
    );
    SummaryState.loadTeamCalendarSummary(summaryData);
    AppState.stopLoading();
};

export const isLoaded = (year, month) => {
    const days = _.keys(getState().calendar.dayTree);
    const dayKey = `${year}_${month}_15`;
    return _.any(days, (day) => day === dayKey);
};

export const loadProgramWorkouts = async (
    programId,
    programType,
    year,
    month,
    data
) => {
    year = parseInt(year, 10);
    month = parseInt(month, 10);

    if (!programId) {
        return;
    }

    const onFail = () => NavState.redirectToTypeList(programType);

    if (ProgramTypes.isProgram(programType)) {
        data = await API.ProgramService.getProgramById(programId, onFail);
        return addProgramWorkoutsToCalendar(data.programWorkouts);
    }

    if (!data) {
        data = await API.ProgramService.getByIdWithDateRange(
            programId,
            year,
            month,
            7,
            onFail
        );
    }

    addProgramWorkoutsToCalendar(data.programWorkouts);

    if (data.teamSubscriptions) {
        for (let i = 0; i < data.teamSubscriptions.length; i++) {
            const teamSubscription = data.teamSubscriptions[i];
            addProgramWorkoutsToCalendar(teamSubscription.programWorkouts);
        }
    }
};

export const addProgramWorkoutsToCalendar = (programWorkouts) => {
    const programWorkoutsToAdd = normalize(programWorkouts, [workoutSchema]);
    getStore().dispatch({
        type: ACTIONS.CALENDAR_ADD_PROGRAM_WORKOUTS,
        payload: programWorkoutsToAdd,
        programType: getState().calendar.infoTree.programType
    });
};

const setupProgramInfo = async (programId, athleteId, programType) => {
    programId = parseInt(programId, 10);
    if (getState().calendar.infoTree.programId === programId) {
        return;
    }

    const program = await API.ProgramService.getById(programId);

    const isCoachAthleteCalendar =
        programType === ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR;
    const isPersonalCalendar =
        program.type === ProgramTypes.TYPES.ATHLETE_CALENDAR;
    if (programType !== program.type) {
        if (!(isCoachAthleteCalendar && isPersonalCalendar)) {
            return NavState.redirectToTypeList(programType);
        }
    }

    setProgramId(program.id);
    setProgramType(program.type);

    getStore().dispatch({
        type: ACTIONS.CALENDAR_SET_TEAM,
        team: program,
        athleteId
    });
};

export const getAllDaysFromCalendar = (
    currentDate,
    programCalendar,
    week,
    day
) => {
    let dm = {};
    let obj = {};
    if (!ProgramTypes.isProgram(programCalendar.type)) {
        const currentDateLoaded = currentDate.toDate();
        dm = _.filter(programCalendar.data.days, (day) =>
            DateUtils.isSameDay(day.date, currentDateLoaded)
        )[0];

        obj = {
            days: programCalendar.data.days,
            currentDay: `${dm.year}_${dm.month}_${dm.day}`
        };
    } else {
        dm.week = week;
        dm.day = day;
        if (!dm.week || !dm.day) {
            dm.week = dm.week ? dm.week : 0;
            dm.day = dm.day ? dm.day : 0;
        }
        obj = {
            days: programCalendar.data.days,
            currentDay: `${dm.week}_${dm.day}`,
            isProgram: true
        };
    }

    return obj;
};

export const toggleSaveSessionToLibrary = (open = true, session) => {
    getStore().dispatch({
        type: ACTIONS.UI_SAVE_SESSION_TO_LIBRARY_DIALOG,
        saveSessionToLibraryDialog: open,
        session
    });
};

export const saveSessionToLibrary = async (session) => {
    const newWorkout = await WorkoutService.saveWorkoutAsTemplate20(
        session.workout_id,
        session
    );
    getStore().dispatch({
        type: ACTIONS.LIBRARY_SESSION_ADD,
        session: newWorkout
    });
    toggleSaveSessionToLibrary(false, newWorkout);
    ToastState.showSuccessMessage('Session Saved in Library');
};

export const loadSessionPreview = async (programWorkoutId) => {
    const athleteId = getState().calendar.infoTree.athleteId;
    const preview = await API.ProgramService.getProgramWorkoutPreviewAndSummary(
        programWorkoutId,
        athleteId
    );
    return preview;
};

export const loadSessionPreviewForUser = async (programWorkoutId, userId) => {
    const preview = await API.ProgramService.getProgramWorkoutPreviewAndSummary(
        programWorkoutId,
        userId
    );
    return preview;
};

export const overrideExtraSession = (dayKey, programWorkoutId) => {
    const day = getState().calendar.dayTree[dayKey];
    const extraWorkDay = getState().calendar.extraWorkTree[dayKey];
    let session = false;
    for (let i = 0; i < extraWorkDay.length; i++) {
        if (extraWorkDay[i].pw_id === programWorkoutId) {
            session = {
                data: extraWorkDay[i]
            };
        }
    }

    if (!session) return;

    removeExtraSession(dayKey, programWorkoutId);
    addFakeSessionToDay(day);
    API.ProgramService.overrideAndCopy(
        session.data.program_id,
        getProgramId(),
        session.data.pw_id,
        'team'
    ).then((response) => {
        const newSession = { ...response, sets: [], setKeys: [] };

        getStore().dispatch({
            type: DESIGNER_ACTIONS.SESSION_ADD,
            day,
            session: newSession
        });

        for (let i = 0; i < response.sets.length; i++) {
            const key = response.sets[i].id;
            const block = {
                ...response.sets[i],
                key,
                exercises: [],
                exerciseKeys: []
            };
            getStore().dispatch({
                type: DESIGNER_ACTIONS.BLOCK_ADD,
                session: newSession,
                block
            });
            for (let j = 0; j < response.sets[i].exercises.length; j++) {
                const key = response.sets[i].exercises[j].id;
                const exercise = { ...response.sets[i].exercises[j], key };
                getStore().dispatch({
                    type: DESIGNER_ACTIONS.BLOCK_ADD_EXERCISE,
                    block,
                    exercise
                });
            }
        }
        document.body.classList.remove('fixWindow');
    });
};

export const removeExtraSession = (dayKey, programWorkoutId) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_REMOVE_EXTRA,
        dayKey,
        programWorkoutId
    });
};

export const calendarDayHover = (dayKey) => {
    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_DAY_HOVER,
        dayKey
    });
};

export const performSessionAction = async (dayKey, session, action) => {
    switch (action) {
        case WORKOUT_ACTIONS.PUBLISH:
            if (!Authorization.publishSession.isAllowed())
                return AppState.showUnauthorizedDialog();

            var published = session.published === 1 ? 0 : 1;
            DesignerState.togglePublished(
                getStore().dispatch,
                { data: session },
                published
            );
            ClipboardState.clearSelected();
            break;
        case WORKOUT_ACTIONS.SAVE:
            // Disable selectable to prevent any weird behavior
            // when user types something in a textfield

            toggleSaveSessionToLibrary(true, session);
            break;
        case WORKOUT_ACTIONS.EDIT:
            const designerUrl = getDesignerUrl(session);
            ClipboardState.clearSelected();
            AppState.navigate(designerUrl);
            break;
        case WORKOUT_ACTIONS.COPY_AND_EDIT:
            if (!Authorization.publishSession.isAllowed())
                return AppState.showUnauthorizedDialog();
            const day = getState().calendar.dayTree[dayKey];
            await DesignerState.copyAndReplace(day, session);
            const url = getDesignerUrl(session);
            ClipboardState.clearSelected();
            AppState.navigate(url);
            break;
        case WORKOUT_ACTIONS.COPY:
            ClipboardState.select([session.id]);
            ClipboardState.copy();
            ClipboardState.clearSelected();
            break;
        case WORKOUT_ACTIONS.REPEAT:
            ClipboardState.select([session.id]);
            ClipboardState.showRepeatDialog();
            break;
        case WORKOUT_ACTIONS.DELETE:
            ClipboardState.select([session.id]);
            ClipboardState.showDeleteDialog();
            break;
        case WORKOUT_ACTIONS.PREVIEW: {
            const previewPath = `/fullscreen-workout/${session.workout_id}`;
            window.open(previewPath, '_blank');
            ClipboardState.clearSelected();
            break;
        }
        default:
            break; // do nothing
    }
};

export const deleteSession = (dispatch, _day, session) => {
    if (!dispatch) {
        dispatch = getStore().dispatch;
    }
    dispatch({
        type: ACTIONS.UI_SAVING,
        isSaving: true
    });
    dispatch({
        type: ACTIONS.UI_SAVING,
        isSaving: false
    });
    dispatch({
        type: ACTIONS.SESSION_DELETE,
        session,
        day: _day
    });
    dispatch({
        type: ACTIONS.UI_DELETE_DIALOG,
        isOpen: false
    });
    ToastState.showSuccessMessage('Session Deleted');
    API.ProgramService.removeProgramWorkout(session.program_id, session.id);
};

export const dropCalendarSession = (fromDayKey, targetDayKey, sessionKey) => {
    if (fromDayKey === targetDayKey) {
        return;
    }
    let session = getState().calendar.sessionTree[sessionKey].data;
    const day = getState().calendar.dayTree[targetDayKey];

    let timeline_day = null;
    if (programType === 2) {
        timeline_day = getState().calendar.dayList.indexOf(targetDayKey) + 1;
    }

    if (day.day && day.month && day.year) {
        session = {
            ...session,
            day: day.day,
            month: day.month,
            year: day.year,
            date: `${day.year}-${day.month}-${day.day}`,
            timeline_day
        };
    } else {
        session = {
            ...session,
            day: '',
            month: '',
            year: '',
            date: '',
            timeline_day
        };
    }

    API.ProgramService.saveProgramWorkouts([session]).then((response) => {
        getStore().dispatch({
            type: ACTIONS.UI_CALENDAR_DAY_HOVER,
            dayKey: false
        });

        getStore().dispatch({
            type: ACTIONS.SESSION_UPDATE,
            session: {
                ...session,
                title: response[0].title
            }
        });

        getStore().dispatch({
            type: ACTIONS.DND_CAL_SESSION,
            fromDayKey,
            targetDayKey,
            session,
            sessionKey,
            day
        });
    });
};

export const editSessionOverlay = (ev, session) => {
    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_SESSION_EDIT_OVERLAY,
        session: { id: session.id },
        open: true,
        action: 'open'
    });
};

export const fakeSession = {
    data: {
        fake: true,
        workout_id: 'fakeSession',
        workoutSets: []
    }
};

export const getDesignerUrl = (
    session,
    year,
    month,
    day,
    weekIndex,
    dayIndex
) => {
    let designerUrl = '';
    const programType = getState().calendar.infoTree.programType;
    const programId = getState().calendar.infoTree.programId;

    if (session) {
        year = parseInt(session.year, 10);
        month = parseInt(session.month, 10);
        day = parseInt(session.day, 10);
    }

    if (ProgramTypes.isCoachAthleteCalendar(programType)) {
        const athleteId = getState().calendar.infoTree.athleteId;
        designerUrl = `/athlete/${athleteId}/${year}/${month}/${day}`;
    } else if (ProgramTypes.isInvitedAthleteCalendar(programType)) {
        const athleteId = getState().calendar.infoTree.athleteId;
        designerUrl = `/athlete/invite/${athleteId}/${year}/${month}/${day}`;
    } else if (ProgramTypes.isCalendar(programType)) {
        designerUrl = `/calendar/${programId}/${year}/${month}/${day}`;
    } else if (ProgramTypes.isTeamCalendar(programType)) {
        designerUrl = `/team/${programId}/${year}/${month}/${day}`;
    } else {
        if (!weekIndex && !dayIndex) {
            const timelineDay = session.timeline_day;
            const indexDay = timelineDay - 1;
            weekIndex = Math.floor(indexDay / 7);
            dayIndex = indexDay - weekIndex * 7;
        }
        designerUrl = `/program/${programId}/${weekIndex}/${dayIndex}`;
    }

    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_SESSION_EDIT_URL,
        designerUrl
    });

    if (session) {
        getStore().dispatch({
            type: ACTIONS.UI_CALENDAR_SESSION_SCROLL_KEY,
            designerScrollKey: session.workout_id
        });
    }

    return designerUrl;
};

export const inform = (open, title, message) => {
    getStore().dispatch({
        type: ACTIONS.UI_INFORM,
        open,
        title,
        message
    });
};

export const loadCalendarPrograms = (calendars) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_PROGRAMS_LOAD,
        calendars
    });
};

/*
 * debouncedRenderMonth - This function pulls out the render of the actual days
 * from the switching, this allows the user to rapid fire switch months, and
 * since the rendering of a day is expensive from a render standpoint,
 * we wait until they settle on a month to normalize and render them
 */
const debouncedRenderMonth = _.debounce(
    (
        programId,
        currentDay,
        _days,
        programType,
        year,
        month,
        fixedProgramLength
    ) => {
        setupCalendarHeaders(programId, programType);
        const payload = normalize(_days, [daySchema]);
        const dateKey = ProgramTypes.isProgram(programType)
            ? currentDay
            : DateUtils.convertToDate(currentDay, 'YYYY_MM_DD').format(
                  'YYYY-MM'
              );

        getStore().dispatch({
            type: ACTIONS.CALENDAR_SETUP,
            programType,
            payload,
            year,
            month,
            currentDay,
            dateKey,
            programLength: fixedProgramLength
        });
    },
    100
);

export const calendarSetup = async (
    programId,
    currentDay,
    _days,
    programType,
    year,
    month,
    fixedProgramLength
) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_SETUP,
        programType,
        payload: { entities: { days: [] }, result: [] },
        year,
        month,
        currentDay,
        programLength: fixedProgramLength
    });

    await debouncedRenderMonth(
        programId,
        currentDay,
        _days,
        programType,
        year,
        month,
        fixedProgramLength
    );
};

export const loadDrawerInfo = (data) => {
    getStore().dispatch({
        type: ACTIONS.DRAWER_LOAD_INFO,
        data
    });
};

export const loadExtraWork = (extraWork) => {
    for (let i = 0; i < extraWork.length; i++) {
        const extra = extraWork[i];
        extra.key = Utils.getDayKey(extra);
    }
    getStore().dispatch({
        type: ACTIONS.CALENDAR_EXTRA_LOAD,
        extraWork
    });
};

export const loadNutrition = (nutrition) => {
    for (let i = 0; i < nutrition.length; i++) {
        const extra = nutrition[i];
        extra.key = Utils.getDayKey(extra);
    }
    getStore().dispatch({
        type: ACTIONS.NUTRITION_LOAD,
        nutrition
    });
};

export const loadSubscribedTeams = (dispatch, teams) => {
    dispatch({
        type: ACTIONS.CALENDAR_PROGRAMS_ADD,
        teams
    });
};

export const loadLibrarySessions = (dispatch, sessions) => {
    dispatch({
        type: ACTIONS.LIBRARY_SESSIONS_LOAD,
        sessions
    });
    dispatch({
        type: ACTIONS.UI_DRAWER_LOADING,
        drawerLoading: false
    });
};

export const loadFixedPrograms = (dispatch, programs) => {
    dispatch({
        type: ACTIONS.FIXED_PROGRAMS_LOAD,
        programs
    });
};

export const overrideApiService = (serviceName, service) => {
    API[serviceName] = service;
};

function trackSessionPublishedAll(sessionsPublished) {
    const team = getState().calendar.infoTree.team;
    const calendarType = ProgramTypes.convertToString(team.type);
    const dateRange = {
        start: '2990-01-01',
        end: '1990-01-01'
    };
    for (let i = 0; i < sessionsPublished.length; i++) {
        const session = sessionsPublished[i];
        const date = Date.parse(session.date);
        if (date < Date.parse(dateRange.start)) {
            dateRange.start = session.date;
        }
        if (date > Date.parse(dateRange.end)) {
            dateRange.end = session.date;
        }
    }
    SegmentService.track(SEGMENT_EVENTS.SessionPublishedAll.key, {
        userId: getState().app.loggedInUser.id,
        email: getState().app.loggedInUser.email,
        calendarType: calendarType,
        numSessions: sessionsPublished.length,
        teamId: team.group_id,
        programId: team.id,
        dateFirstSession: dateRange.start,
        dateLastSession: dateRange.end
    });
}

export const publishAllProgramWorkouts = async () => {
    const ids = [];
    const sessionsPublished = [];
    const sessions = getState().calendar.sessionTree;
    Object.keys(sessions).forEach((key) => {
        const session = sessions[key].data;
        if (session.published !== 1 && !session.fake) {
            ids.push(session.id);
            sessionsPublished.push(session);
            getStore().dispatch({
                type: ACTIONS.SESSION_UPDATE,
                session: {
                    ...session,
                    published: 1
                }
            });
        }
    });
    await API.ProgramService.publishProgramWorkouts(ids);
    trackSessionPublishedAll(sessionsPublished);
    ToastState.showSuccessMessage('Sessions published!');
};

export const reloadCalendarDrawer = () => {
    getStore().dispatch({
        type: ACTIONS.UI_RELOAD_DRAWER
    });
};

export const reloadDays = (dispatch, currentDay, _days, teamId) => {
    const payload = normalize(_days, [daySchema]);
    return dispatch({
        type: ACTIONS.DAYS_RELOAD,
        payload,
        currentDay,
        teamId
    });
};

export const removeSession = (dispatch, _day, session) => {
    dispatch({
        type: ACTIONS.SESSION_DELETE,
        session,
        day: _day
    });
};

export const toggleHeaderCollapse = (key, dayHeader) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_TOGGLE_DAY_HEADER_TOGGLE,
        key,
        dayHeader
    });
};

export const setDragging = (isDragging) => {
    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_DRAGGING,
        isDragging
    });
};

export const setExtraWorkViewOptions = (viewOptions) =>
    getStore().dispatch({
        type: ACTIONS.CALENDAR_EXTRA_VIEW_OPTIONS,
        viewOptions
    });

export const setTooltipContent = (content) => {
    getStore().dispatch({
        type: ACTIONS.UI_SET_TOOLTIP_CONTENT,
        content
    });
};

export const setupCalendarHeaders = (programId, programType) => {
    let key = CalendarCollapseState.getKey(programType, programId);
    getStore().dispatch({
        type: ACTIONS.CALENDAR_LOAD_DAY_HEADERS,
        key
    });
};

export const updateTooltipContent = (content) => {
    getStore().dispatch({
        type: ACTIONS.UI_UPDATE_TOOLTIP_CONTENT,
        content
    });
};

let previewTimeoutId;
let previewOut = false;
export const showPreview = async (item, position, type = null) => {
    previewOut = !item && !position;
    if (type) {
        // we are showing a session preview
        const preview = await API.ProgramService.getPreview(
            type,
            item.id,
            item
        );
        preview.typeElement = item.typeElement;
        preview.icon = item.icon || item.team_logo;
        if (!previewOut) {
            getStore().dispatch({
                type: ACTIONS.UI_PREVIEW,
                item: preview,
                previewPosition: position
            });
        }
    } else {
        const WAIT = 200;
        if (previewTimeoutId) {
            previewTimeoutId = clearTimeout(previewTimeoutId);
        }
        previewTimeoutId = setTimeout(() => {
            getStore().dispatch({
                type: ACTIONS.UI_PREVIEW,
                item,
                previewPosition: position
            });
        }, WAIT);
    }
};

export const toggleBasicDrawer = (open) => {
    open = !!open;
    getStore().dispatch({
        type: ACTIONS.UI_BASIC_DRAWER,
        drawerOpen: open
    });
    getStore().dispatch({
        type: ACTIONS.FEED_CARD_LOAD,
        card: null
    });
    // getStore().dispatch({
    //     type:ACTIONS.FEED_REFRESH,
    //     refreshInput:false
    // });
};

export const cancelPreview = () => {
    if (previewTimeoutId) {
        previewTimeoutId = clearTimeout(previewTimeoutId);
    }
};

export const openAutoPublishSettings = () => {
    if (!Authorization.publishSession.isAllowed()) {
        return AppState.showUnauthorizedDialog();
    }
    getStore().dispatch({
        type: ACTIONS.CALENDAR_OPEN_AUTOPUBLISH_SETTINGS
    });
};

export const toggleCalendarInstructions = () =>
    getStore().dispatch({
        type: ACTIONS.CALENDAR_TOGGLE_INSTRUCTIONS
    });

export const toggleCalendarBlockNames = () => {
    // localStorage.setItem('block-names-visibility', JSON.stringify(mode));
    getStore().dispatch({
        type: ACTIONS.CALENDAR_TOGGLE_BLOCK_NAMES
    });
};

// todo: aryn refactor out dispatch
export const toggleDeleteSessionDialog = (
    dispatch,
    _day,
    session,
    isOpen,
    title
) => {
    if (!dispatch) {
        dispatch = getStore().dispatch;
    }
    dispatch({
        type: ACTIONS.UI_DELETE_DIALOG,
        day: _day,
        session,
        bind: {
            title,
            type: 'Session'
        },
        isOpen
    });
};

export const selectDay = (day) => {
    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_DAY_SELECT,
        day
    });
};

export const toggleSideNav = (open) => {
    showPreview(null, null);
    if (!open) {
        selectDay(null);
    }
    ClipboardState.toggleCalendarHotkeys(!open);
    getStore().dispatch({
        type: ACTIONS.UI_CALENDAR_SIDENAV,
        calendarSideNavOpen: open
    });
};

export const undoRemoveSession = (dispatch, _day, session) => {
    dispatch({
        type: ACTIONS.SESSION_DELETE_UNDO,
        session,
        day: _day
    });
    API.ProgramService.undoRemoveProgramWorkout(
        session.data.program_id,
        session.data.id
    );
};

export const updateCalendarSessionOrder = (dayKey, newOrder) => {
    getStore().dispatch({
        type: ACTIONS.DND_CAL_SESSION_ORDER,
        dayKey,
        newOrder
    });
};

export const updateSelectItems = (items) => {
    const itemIds = [];
    for (let i = 0; i < items.length; i++) {
        itemIds.push(parseInt(items[i].getAttribute('id'), 10));
    }
    getStore().dispatch({
        type: ACTIONS.CALENDAR_SESSION_SELECT,
        itemIds
    });
    return itemIds;
};

export const updateTeamOptions = (team) => {
    // aryn
    getStore().dispatch({
        type: ACTIONS.CALENDAR_SET_TEAM,
        team
    });
    ToastState.showLoadingMessage('Saving Settings...');
    TeamService.updatePublishSettings(team);
};

export const toggleDrawerCalendarDialog = (open, item, totalDays = 0) => {
    const dialogType = item.typeElement;
    getStore().dispatch({
        type: ACTIONS.UI_ADD_DRAWER_DIALOG,
        open,
        dialogType,
        item,
        totalDays
    });
};

export const showLoading = () => {
    getStore().dispatch({
        type: ACTIONS.UI_LOADING,
        isLoading: true
    });
};

export const hideLoading = () => {
    getStore().dispatch({
        type: ACTIONS.UI_LOADING,
        isLoading: false
    });
};

export const saveCalendar = async (calendar, teamId, year, month) => {
    showLoading();
    let response = null;
    response = await API.ProgramService.subscribeToProgram(
            teamId,
            calendar.id,
            year,
            month,
            10
        );

    const sessions = response.programWorkouts || [];

    getStore().dispatch({
        type: ACTIONS.CALENDAR_PROGRAMS_SUBSCRIBE,
        calendar
    });

    if (sessions.length) {
        sessions.map((s) => {
            s.calendar_subscription = calendar.id;
            return addSession(s, false);
        });
    }
    ToastState.showSuccessMessage('Calendar successfully subscribed.');
    hideLoading();
};

export const unsubscribeCalendar = async (calendar, teamId) => {
    showLoading();
    ToastState.showSuccessMessage('Unsubscribing...');
    toggleDrawerCalendarDialog(false, calendar);
    toggleSideNav(false);
    TeamService.deleteSubscription(teamId, calendar.id);

    await DesignerState.unsubscribeCalendar(calendar);

    getStore().dispatch({
        type: ACTIONS.CALENDAR_PROGRAMS_UNSUBSCRIBE,
        calendar
    });

    ToastState.showSuccessMessage('Calendar unsubscribed');
    hideLoading();
};

export const addProgram = async (program) => {
    setTimeout(() => {
        ToastState.showLoadingMessage('Adding program...');
    }, 0);

    const savedProgram = await API.ProgramService.addProgramToCalendar(program);
    const sessions = savedProgram.program_workouts;
    sessions.map((s) => addSession(s, false));
    ToastState.showSuccessMessage('Program added!');
};

export const updateProgramLength = (weeksLength) => {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_PROGRAM_UPDATE_LENGTH,
        weeksLength
    });
};

export const bulkPublishSessions = async (sessionIds, publish) => {
    const sessionTree = getState().calendar.sessionTree;

    const sessionPWIds = [];
    _.each(sessionIds, (s) => {
        const session = sessionTree[s.id];
        if (session.teamSubscription) return;
        sessionPWIds.push(s.pwId);

        getStore().dispatch({
            type: ACTIONS.SESSION_UPDATE,
            session: {
                ...session.data,
                published: publish ? 1 : 0
            }
        });
    });

    if (publish) {
        await API.ProgramService.publishProgramWorkouts(sessionPWIds);
    } else {
        await API.ProgramService.unpublishProgramWorkouts(sessionPWIds);
    }

    return ToastState.showSuccessMessage(
        `Session${sessionPWIds.length > 1 ? 's' : ''} ${
            publish ? 'Published' : 'Unpublished'
        } `
    );
};

// todo : refactor these to use redux instead of storing here
let programId = null;
let prevProgramId = null;
export const setProgramId = function (id) {
    prevProgramId = programId;
    programId = id;
    getStore().dispatch({
        type: ACTIONS.CALENDAR_SET_PROGRAM_ID,
        programId
    });
};

export const getPreviousProgramId = function () {
    return prevProgramId;
};

export const getProgramId = function () {
    return getState().calendar.infoTree.programId;
};

let programType = null;
export const setProgramType = function (type) {
    programType = type;
};

export const getProgramType = function () {
    return getState().calendar.infoTree.programType;
};

export const setAthleteId = function (id) {
    getStore().dispatch({
        type: ACTIONS.CALENDAR_ATHLETE_INFO,
        currentUser: id
    });
};

export const clearInfoTree = () => {
    getStore().dispatch({
        type: ACTIONS.CLEAR_INFO_TREE
    });
};

export const getAthleteId = function () {
    return getState().calendar.infoTree.athleteId;
};

export const isDateOnCalendar = (date) => {
    const _date = DateUtils.convertDate(date);
    const dayKey = Utils.getDayKey(_date);
    const day = getState().calendar.dayTree[dayKey];
    return !!day;
};

export const navigate = (id, programType, year, month) => {
    const programTypeString = ProgramTypes.convertToString(programType);

    if (ProgramTypes.isProgram(programType)) {
        return AppState.navigate(`/${programTypeString}/${id}`);
    }

    return AppState.navigate(`/${programTypeString}/${id}/${year}/${month}`);
};
